import fetch from '../../api/fetch';
import { FIREBASE_DRILL_COLLECTION_DB, REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';

export const listFirebaseDrillCollections = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_LIST_LOADING,
  });

  const body = { DB: FIREBASE_DRILL_COLLECTION_DB };

  return fetch
    .post('firebase/Collections', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_LIST_SUCCESS,
        payload: data,
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const getFirebaseDrillData = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_LOADING,
  });

  const body = {
    DB: FIREBASE_DRILL_COLLECTION_DB,
    ...payload
  };

  return fetch
    .post('firebase/getData', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_SUCCESS,
        payload: {
          data: data.map((item, index) => ({
            ...(typeof item.details === 'object' && !Array.isArray(item.details) ? item.details : item),
            ...(typeof item.details === 'object' && !Array.isArray(item.details) && { lastUpdate: item.lastUpdate }),
            grid_id: index
          })),
          paginatedElements: data.length,
          filterByDetail: typeof data[0].details === 'object' && !Array.isArray(data[0].details)
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
